import { m } from "framer-motion";
import React from "react";

const included = [
	"Job stays live until deadline or 30 days",
	"Unlimited deadline edits within 30 days",
	"A dedicated company hiring page",
	"Promotion across our job board, socials, WhatsApp, and email digest",
	"Optional 30-day extension for 29,000 TZS",
];

const noStrings = ["No monthly subscription", "No per-candidate fees", "No account required"];

function PricingSection() {
	return (
		<section className="py-20 sm:py-28">
			<m.div
				initial={{ opacity: 0, y: 24 }}
				whileInView={{ opacity: 1, y: 0 }}
				viewport={{ once: true, margin: "-80px" }}
				transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
				className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16"
			>
				<div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-start">
					{/* Left — the price as hero moment */}
					<div className="lg:col-span-7">
						<div className="flex items-center gap-3 mb-10">
							<span className="h-[1.5px] w-10 bg-blue-700" />
							<span className="font-inter text-xs font-semibold text-blue-700 tracking-[0.2em] uppercase">
								Simple pricing
							</span>
						</div>

						<div className="flex items-start gap-4 mb-10">
							<span className="font-plus-jakarta font-black text-blue-800 leading-[0.82] tracking-[-0.045em] text-[clamp(4.5rem,14vw,11rem)]">
								49k
							</span>
							<div className="flex flex-col pt-3 sm:pt-5">
								<span className="font-inter text-sm font-semibold text-gray-900">TZS</span>
								<span className="font-inter text-xs text-gray-500 mt-1">per job</span>
							</div>
						</div>

						<h2 className="font-plus-jakarta text-3xl sm:text-4xl lg:text-[2.5rem] font-bold text-gray-900 leading-[1.1] tracking-tight mb-5 max-w-lg">
							One flat fee.
							<br />
							Everything included.
						</h2>
						<p className="font-inter text-base text-gray-500 leading-relaxed max-w-md mb-10">
							No setup costs. No monthly subscription. Post a job and reach qualified candidates across Tanzania.
						</p>

						<div className="flex flex-wrap gap-x-6 gap-y-3">
							{noStrings.map((item) => (
								<span key={item} className="inline-flex items-center gap-2 font-inter text-sm text-gray-600">
									<span className="w-1 h-1 rounded-full bg-blue-700" />
									{item}
								</span>
							))}
						</div>
					</div>

					{/* Right — editorial numbered list */}
					<div className="lg:col-span-5 lg:pt-2">
						<div className="flex items-center gap-3 mb-8">
							<span className="font-inter text-xs font-semibold text-gray-500 tracking-[0.2em] uppercase">
								What's included
							</span>
							<span className="h-[1.5px] flex-1 bg-gray-200" />
						</div>
						<ul className="space-y-0">
							{included.map((feature, i) => (
								<m.li
									key={feature}
									initial={{ opacity: 0, y: 14 }}
									whileInView={{ opacity: 1, y: 0 }}
									viewport={{ once: true, margin: "-40px" }}
									transition={{ duration: 0.5, delay: 0.15 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
									className="flex items-baseline gap-5 py-5 border-b border-gray-100 last:border-0"
								>
									<span className="font-plus-jakarta text-xs font-bold text-blue-700 tabular-nums shrink-0">
										0{i + 1}
									</span>
									<span className="font-inter text-[15px] text-gray-700 leading-relaxed">{feature}</span>
								</m.li>
							))}
						</ul>
					</div>
				</div>
			</m.div>
		</section>
	);
}

export default PricingSection;
